// 0065: aanmelden (wizard /aanmelden), Instellingen › Abonnement, de banner na de proefmaand en
// de conceptvoorwaarden. Toon: je-vorm, korte zinnen, geen druk. {price} = bedrag met valuta,
// {date} = datum voluit, {n} = aantal dagen, {email} = gemaskeerd adres.
export const appBillingNl = {
    signup: {
        /** De acht stappen van de aanmeldflow (voortgang bovenaan). */
        steps: ['Welkom', 'Account', 'Bevestigen', 'Huishouden', 'Leden', 'Modules', 'Bord', 'Klaar'],
        stepOf: 'Stap {n} van {total}: {name}',
        welcomeTitle: 'Welkom bij AMUMIN Family Board',
        welcomeBody: 'Een rustig bord voor jullie huishouden: de agenda, taken en meer, op een tablet aan de muur en in deze app.',
        trialLine: 'De eerste maand is gratis. Je hoeft nu geen betaalgegevens in te vullen.',
        languageLabel: 'In welke taal wil je verder?',
        start: 'Beginnen',
        closedTitle: 'Aanmelden is nog niet open',
        closedBody: 'We openen binnenkort. Zet je op de wachtlijst, dan sturen we je een uitnodiging.',
        closedLink: 'Naar de wachtlijst',
        haveAccount: 'Heb je al een account?',
        login: 'Inloggen',
        accountTitle: 'Je account',
        accountBody: 'Hiermee log je in. Je e-mailadres gebruiken we alleen voor je account, nooit voor reclame.',
        name: 'Je voornaam',
        nameHint: 'Zo noemt het bord je. Later te wijzigen.',
        nameRequired: 'Vul je voornaam in.',
        email: 'E-mailadres',
        method: 'Hoe wil je inloggen?',
        methodPassword: 'Met een wachtwoord',
        methodLink: 'Mail me een link',
        methodLinkHint: 'Je krijgt een code en een knop per mail. Later kun je altijd nog een wachtwoord kiezen.',
        priceLine: '1 maand gratis, daarna {price} per maand. Je kunt altijd opzeggen.',
        priceLinePlaceholder: '1 maand gratis, daarna betaal je per maand. De prijs hoor je ruim vóór het einde. Je kunt altijd opzeggen.',
        termsBefore: 'Ik ga akkoord met de',
        termsLink: 'voorwaarden',
        termsAnd: 'en de',
        privacyLink: 'privacyverklaring',
        termsRequired: 'Vink dit aan om verder te gaan.',
        createAccount: 'Account maken',
        verifyTitle: 'Bevestig je e-mailadres',
        verifyIntro: 'We stuurden een code naar {email}. Typ hem hieronder, of klik op de knop in de mail.',
        verifyHint: 'Geen mail? Kijk ook bij ongewenste mail, of vraag hieronder een nieuwe code.',
        otherEmail: 'Ander e-mailadres',
        linkBusy: 'Even je e-mailadres bevestigen…',
        linkVerifiedTitle: 'Je e-mailadres is bevestigd',
        linkVerifiedBody: 'Je proefmaand is begonnen. Ga verder in de browser waar je begon, of log hier in.',
        linkInvalid: 'Deze link is verlopen of al gebruikt. Log in, of meld je opnieuw aan.',
        modulesTitle: 'Wat wil je gebruiken?',
        modulesBody: 'Alles is een keuze. Voor jullie soort huishouden staat dit alvast aan; zet aan of uit wat je wilt. Later wijzigen kan altijd bij Instellingen › Modules.',
        profileTitle: 'Geloof, eten en bijzondere dagen',
        profileBody: 'Alleen als je wilt. Je kiest het zelf en geeft er apart toestemming voor.',
        profileButton: 'Kiezen',
        boardTitle: 'Een tablet als bord',
        boardBody: 'Zet een tablet aan de muur en koppel hem met de QR-code. Geen tablet bij de hand? Dat kan later ook, bij Instellingen › Tablets.',
        boardQr: 'Koppel met QR-code',
        boardCode: 'Koppel met een code',
        doneTitle: 'Welkom, alles staat klaar',
        doneTrial: 'Je proefmaand loopt tot en met {date}.',
        doneNext: [
            'Een week voor het einde sturen we je een herinnering.',
            'Wil je daarna doorgaan? Voeg je betaalgegevens toe bij Instellingen › Abonnement. Doe je niets, dan kun je alles nog bekijken, maar niet meer wijzigen.',
            'Je kunt altijd opzeggen. We wissen nooit vanzelf iets.',
        ],
        toApp: 'Naar de app',
    },
    page: {
        title: 'Abonnement',
        settingsHint: 'Proefmaand, betalen en facturen',
        offTitle: 'Nog geen abonnementen',
        offBody: 'Je gebruikt AMUMIN Family Board nu zonder abonnement.',
        noneTitle: 'Geen abonnement nodig',
        noneBody: 'Dit gezinsbord heeft geen abonnement.',
        status: {
            trial: 'Proefmaand',
            active: 'Actief',
            past_due: 'Betaling niet gelukt',
            paused: 'Gepauzeerd',
            cancelled: 'Opgezegd',
            expired: 'Alleen kijken',
        },
        trialLeft: 'Nog {n} dagen gratis, tot en met {date}.',
        trialLastDay: 'Vandaag ({date}) is je laatste gratis dag.',
        activeUntil: 'Betaald tot {date}.',
        activeOpen: 'Je abonnement loopt.',
        cancelledUntil: 'Opgezegd. Alles werkt nog tot en met {date}.',
        expiredBody: 'Je proefmaand is voorbij. Alles staat er nog; wijzigen kan weer na betalen.',
        pastDueBody: 'De laatste betaling is niet gelukt. Voeg opnieuw betaalgegevens toe.',
        pausedBody: 'AMUMIN heeft je abonnement even gepauzeerd. Alles werkt gewoon.',
        plan: 'Plan',
        perMonth: '{price} per maand',
        pricePlaceholder: 'Prijs volgt',
        payment: 'Betaalgegevens',
        paymentNone: 'Nog geen betaalgegevens.',
        paymentSet: 'Automatische incasso staat klaar.',
        addPayment: 'Betaalgegevens toevoegen',
        soon: 'Binnenkort: betalen met iDEAL en daarna automatische incasso.',
        checkoutTitle: 'Betaalgegevens toevoegen',
        checkoutBody: 'Je betaalt de eerste maand met iDEAL. Daarna schrijven we elke maand automatisch af. Je kunt altijd opzeggen.',
        startNow: 'Ik wil dat de dienst meteen doorloopt. Als ik binnen 14 dagen herroep, betaal ik alleen voor de dagen die ik al gebruikte.',
        startNowRequired: 'Vink dit aan om verder te gaan.',
        toPayment: 'Naar betalen',
        checkoutOpen: 'Er loopt al een betaling. Rond die eerst af, of probeer het over een uur opnieuw.',
        paidReturn: 'Dank je. Zodra de betaling binnen is, zie je het hier.',
        invoices: 'Facturen',
        invoicesNone: 'Nog geen facturen.',
        invoiceStatus: {
            open: 'Open',
            paid: 'Betaald',
            failed: 'Niet gelukt',
            refunded: 'Terugbetaald',
            void: 'Vervallen',
        },
        invoiceLine: '{number} · {period} · {amount}',
        cancel: 'Abonnement opzeggen',
        cancelTitle: 'Abonnement opzeggen?',
        cancelBody: 'Alles blijft werken tot en met {date}. Daarna kun je alles nog bekijken, maar niet meer wijzigen. We wissen niets.',
        cancelConfirm: 'Ja, opzeggen',
        keep: 'Toch niet',
        cancelDone: 'Je abonnement is opgezegd.',
        resume: 'Toch doorgaan',
        resumeDone: 'Fijn, je abonnement loopt door.',
        onlyOwner: 'Alleen de eigenaar kan betalen of opzeggen.',
        deleteHint: 'Wil je alles verwijderen? Dat kan bij Instellingen › Jouw gegevens.',
    },
    banner: {
        expiredTitle: 'Je proefmaand is voorbij',
        expiredBody: 'Je kunt alles nog bekijken. Voeg betaalgegevens toe om weer toe te voegen en te wijzigen.',
        pay: 'Betalen',
        readOnly: 'Je proefmaand is voorbij: wijzigen kan weer na betalen.',
    },
    terms: {
        title: 'Voorwaarden (concept)',
        intro: 'Dit is een concept. De definitieve algemene voorwaarden staan hier voordat aanmelden opengaat.',
        points: [
            'De eerste maand is gratis. Je hoeft daarvoor geen betaalgegevens te geven.',
            'Daarna betaal je per maand of per jaar, vooraf. Opzeggen kan altijd; het loopt dan tot het einde van de betaalde periode.',
            'Na de proefmaand zonder betaling kun je alles nog bekijken, maar niet meer wijzigen. We wissen nooit vanzelf iets.',
            'Als consument heb je 14 dagen herroepingsrecht vanaf het moment dat je gaat betalen.',
            'Hoe we met je gegevens omgaan, staat in de privacyverklaring.',
        ],
    },
};
//# sourceMappingURL=billingApp.nl.js.map